import Vue from 'vue'

export default function () {
  Vue.directive('autofocus', {
    inserted(el) {
      Vue.nextTick(() => el.focus());
    }
  })
  Vue.directive('no-special-chars', {
    bind(el) {
      const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
      input.addEventListener('input', (e) => {
        const regex = /[^a-zA-Z0-9\s\-_\/]/g;
        if (regex.test(e.target.value)) {
          e.target.value = e.target.value.replace(regex, '');
          input.dispatchEvent(new Event('input'));
        }
      });
    }
  })
}